// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f886a42b","238":"c3773ce7","239":"09f93ce7","453":"c911d9ad","732":"ae9b39b9","867":"958544db"}[chunkId] + ".chunk.js";
};